import React, { createContext, useState } from "react";

export const ErrorContext = createContext({
  error: null,
  setError: () => {},
  clearError: () => {},
});

export function ErrorProvider({ children }) {
  const [error, setError] = useState({
    error: null,
    isLabeled: false,
    isDisabled: false,
    isHide: false,
  });

  const clearError = () =>
    setError({
      error: null,
      isLabeled: false,
      isDisabled: false,
      isHide: false,
    });

  return (
    <ErrorContext.Provider value={{ error, setError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
}
